import { configureStore } from '@reduxjs/toolkit'
import { activitiesSlice } from './slices/activities/activitiesSlice'
import { monitorSlice } from './slices/monitor/monitorSlice'
import { rightsSlice } from './slices/rights/rightsSlice'
import { indicatorDisplayFilterSlice } from './slices/indicatorDisplay/SearchAndFilter/filterAndSearchSlice'
import { indicatorSlice } from './slices/indicatorDisplay/indicator/indicatorSlice'
import { researchsSlice } from './slices/researchs/researchsSlice'
import { methodologiesSlice } from './slices/methodologies/methodologySlice'
import { evaluatorSlice } from './slices/evaluator/evaluatorSlice'
import { periodsSlice } from './slices/periods/periodsSlice'
import { OdsPriorityGroupsSlice } from './slices/odsPriorityGroups/odsPriorityGroupsSlice'
import { subscriptionSlice } from './slices/subscription/subscriptionSlice'
import { openDataSlice } from './slices/openData/openDataSlice'
import { openDataFiltersSlice } from './slices/openData/openDataFiltersSlice'
import { indicatorIndexSlice } from './slices/indicatorIndex/indicatorIndexSlice'
import { FAQsSlice } from './slices/FAQs/faqsSlice'

export const store = configureStore({
  reducer: {
    activities: activitiesSlice.reducer,
    researchs: researchsSlice.reducer,
    methodologies: methodologiesSlice.reducer,
    monitor: monitorSlice.reducer,
    rights: rightsSlice.reducer,
    indicator_display_filter: indicatorDisplayFilterSlice.reducer,
    indicator: indicatorSlice.reducer,
    evaluator: evaluatorSlice.reducer,
    periods: periodsSlice.reducer,
    ods_priorityGroups: OdsPriorityGroupsSlice.reducer,
    subscription: subscriptionSlice.reducer,
    open_data: openDataSlice.reducer,
    open_data_filters: openDataFiltersSlice.reducer,
    indicator_index: indicatorIndexSlice.reducer,
    faqs: FAQsSlice.reducer
  }
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch